import { NgComponentOutlet, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, TemplateRef, Type } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { CustomOverlayRef } from '../../../services/custom-overlay.ref';

type SpinnerContent = string | TemplateRef<unknown> | Type<unknown>;

@Component({
  selector: 'ebeihilfe-spinner',
  standalone: true,
  imports: [MatProgressSpinner, NgComponentOutlet, NgTemplateOutlet],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent implements OnInit {
  private readonly ref = inject(CustomOverlayRef);
  public componentContent: Type<unknown> | undefined;
  public content: SpinnerContent | undefined;
  public contentType: 'template' | 'string' | 'component' = 'string';
  public context: { close: () => void } | null = null;
  public stringContent: string | undefined;
  public templateContent: TemplateRef<unknown> | undefined;

  public close(): void {
    this.ref.close();
  }

  public ngOnInit(): void {
    const rawContent = this.ref.content;

    if (typeof rawContent === 'string') {
      this.contentType = 'string';
      this.stringContent = rawContent;
    } else if (rawContent instanceof TemplateRef) {
      this.contentType = 'template';
      this.templateContent = rawContent;
      this.context = {
        close: this.ref.close.bind(this.ref),
      };
    } else if (rawContent) {
      this.contentType = 'component';
      this.componentContent = rawContent;
    }
  }
}
